import Admin from './ProtectedAdmin'

export default Admin
